<template>
  <common-container title="报警趋势" class="bottom-one">
    <LineCharts id="bjqs" :lists="datas" :areaColor="areaColor" :colors="colors" />
  </common-container>
</template>

<script>
  import CommonContainer from "../components/commonContainer/Index";
  import LineCharts from "../components/lineCharts/Index";
  export default{
    name:'BottomOne',
    components: {CommonContainer,LineCharts},
    props: {
      lists: {
        type: Object,
        default: ()=>{}
      },
    },
    watch: {
      lists(val) {
        const {currentMonthAlarm,lastMonthAlarm} = val
        console.log(currentMonthAlarm,lastMonthAlarm)
        let todayDatas = Array(31).fill(0);
        let lastDatas = Array(31).fill(0);
        currentMonthAlarm.reduce((bf,af)=>{
          const {date,num} = af
          bf[date.slice(-2)*1] = num
          return bf
        },todayDatas)
        lastMonthAlarm.reduce((bf,af)=>{
          const {date,num} = af
          bf[date.slice(-2)*1] = num
          return bf
        },lastDatas)
         this.datas = {
          '本月':todayDatas,
          '上月':lastDatas
        }
      }
    },
    data() {
      return {
        colors:['#20af8b','#C6C8CE'],
        areaColor:[],
        datas:{
        }
      }
    },
    methods: {
      initColor() {
        let echarts = this.echarts
        this.areaColor =  [
        new echarts.graphic.LinearGradient(1, 1, 0, 0, [{
              offset: 1,
              color: '#29a657'
          }, {
              offset: 0.4,
              color: '#159f7f'
          }, {
              offset: 0,
              color: '#0098a6'
          }]),
          new echarts.graphic.LinearGradient(1,1, 0, 0, [{
              offset: 1,
              color: '#dcdcdc'
          }, {
              offset: 0.7,
              color: '#eee'
          }, {
              offset: 0,
              color: '#ffffff'
          }])
        ]
      }
    },
    mounted () {
      this.initColor()
      // let todayDatas = [];
      // let lastDatas = [];
      // for(let i=0;i<30;i++){
      //   todayDatas.push(Math.floor(Math.random(0,1)*100))
      //   lastDatas.push(Math.floor(Math.random(0,1)*100))
      // }
      // this.datas = {
      //   '本月':todayDatas,
      //   '上月':lastDatas
      // }
    },
  }
</script>

<style lang="scss" scoped>
  .bottom-one{
    float: left;
    width: 16.66%!important;
    height: 100%;
  }
</style>